import { applyMiddleware, combineReducers, createStore } from "redux";
import { thunk } from "redux-thunk";
import { composeWithDevTools } from "@redux-devtools/extension";
import { partnerReducer } from "../reducers/partnersReducer";
import { appointmentsReducer } from "../reducers/AppointmentsReducer";
import { productsReducer } from "../reducers/productsReducer";
import { tokensReducer } from "../reducers/tokensReducer";
import { userReducer } from "../reducers/userReducer";

const rootReducer = combineReducers({
  getNumber: () => 1,
  partners: partnerReducer,
  products: productsReducer,
  appointments: appointmentsReducer,
  tokens: tokensReducer,
  user: userReducer,
});

const middlewares = [thunk];

const middleware = composeWithDevTools(applyMiddleware(...middlewares));

const initalState = {};

const store = createStore(rootReducer, initalState, middleware);

export default store;
